import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import { getAssignByCourseId, getAssignDetails } from "../api/assignAndQuizApi";
import { getAllMoodleAssign, getAssignInfo, getStatusSubmissions, saveAssignSubmission, uploadAssign, viewAssign, creatSubmission } from "../api/moodleQuizAndAssignApi";
import { handleApiError } from "../api/instanceApi";
import { data } from "react-router-dom";
import { error } from "console";

export const useHandleAssign = (
  params?:any
) => {
  const queryClient = useQueryClient();
  const { data: moodleAssigns, isLoading: isMoodleAssignLoading } = useQuery({
    queryKey: ["moodle-assigns", params],
    queryFn: () => getAllMoodleAssign(params),
    staleTime: 6000,
  });

  const {
    data: statusSubmissions,
    isLoading: isStatusSubmissions,
  } = useQuery({
    queryKey: ["statusAssign", params],
    queryFn: () => getStatusSubmissions(params),
    staleTime: 6000,
    refetchOnWindowFocus: false,
  })

  const saveAssign = useMutation({
    mutationFn: (params: any) => saveAssignSubmission(params),
  
    onSuccess: () => {
      // console.log("Nộp bài thành công", data);
      queryClient.invalidateQueries({
        queryKey: ["statusAssign", params],
      });
    },
  
    onError: (error: any) => {
      handleApiError(error);
    }
  });

  const viewAssignMutation = useMutation({
    mutationFn: (assignId: number | string) => viewAssign(assignId),

    onSuccess: (data, assignId) => {
      queryClient.invalidateQueries({
        queryKey: ["statusAssign", assignId],
      });
      queryClient.invalidateQueries({
        queryKey: ["InfoAssign", assignId],
      });
    },

    onError: (error: any) => {
      handleApiError(error);
    }
  });


  const uploadAssignMutation = useMutation({
    mutationFn: (params: any) => uploadAssign(params),

    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: ["statusAssign", params],
      })
    },
    
    onError: (error: any) => {
      handleApiError(error);
    }
  })

  const creatSubmissionMutation = useMutation({
    mutationFn: (assignId: any) => creatSubmission(assignId),
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: ["statusAssign", params],
      });
    },
    onError: (error: any) => {
      handleApiError(error);
    }
  });

  const {
    data: assignInfo,
    isLoading: isAssignInfo,
  } = useQuery({
    queryKey: ["InfoAssign", params],
    queryFn: () => getAssignInfo(params),
    staleTime: 6000,
  })

  


  return {
    statusSubmissions,
    isStatusSubmissions,
    moodleAssigns,
    isMoodleAssignLoading,
    saveAssign,
    uploadAssignMutation,
    assignInfo,
    isAssignInfo,
    viewAssignMutation,
    creatSubmissionMutation
  };
};
